module.exports = __webpack_public_path__ + "assets/img/81.23d8fd6f.png";